import { render, staticRenderFns } from "./classUserRenderer.vue?vue&type=template&id=0673cb6e&lang=pug&"
import script from "./classUserRenderer.vue?vue&type=script&lang=ts&"
export * from "./classUserRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports